import React from "react";

import { Row, Col } from "react-bootstrap";

const accessDenied = () => {
  return (
    <Row>
      <Col className="well">
        <h2 className="access-denied mt-5">Acesso Negado. Permissões insuficientes para acessar essa página.</h2>
      </Col>
    </Row>
  );
};
export default accessDenied;
